export default __webpack_public_path__ + "static/media/paid.d55f6cab.svg";